/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchRecommendationRequest
 */
export interface PatchRecommendationRequest {
    /**
     * Whether the recommendation should be hidden or visible
     * @type {boolean}
     * @memberof PatchRecommendationRequest
     */
    hidden: boolean;
}

/**
 * Check if a given object implements the PatchRecommendationRequest interface.
 */
export function instanceOfPatchRecommendationRequest(value: object): value is PatchRecommendationRequest {
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    return true;
}

export function PatchRecommendationRequestFromJSON(json: any): PatchRecommendationRequest {
    return PatchRecommendationRequestFromJSONTyped(json, false);
}

export function PatchRecommendationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchRecommendationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hidden': json['hidden'],
    };
}

export function PatchRecommendationRequestToJSON(value?: PatchRecommendationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hidden': value['hidden'],
    };
}

